import {html} from 'lit-html';
import moment from "moment";

// Shows the list of additional supporting links when they exist
const otherLinksList = (otherLinks) => {
  if (!otherLinks || otherLinks.length === 0) return;

  return html`
    <div class="entry-defs other-links">
      <div class="entry-def">
        <dt>Other Links</dt>
        ${otherLinks.map((link, idx) => (
          html`<dd class="other-link"><a target="_blank" href="${link}">${idx+1}</a></dd`
        ))}
    </div>
  `;
}

// Shows attribution note if the item is from an alternative data source that
// we need to acknowledge.
const sourceAttribution = (sourceNotes) => {
  if (!sourceNotes) return;

  if (sourceNotes === "CCCSL") {
    return html`
      <p class="attribution">This item is sourced from the <a target="_blank" href="https://github.com/amel-github/covid19-interventionmeasures">CCCSL: CSH Covid-19 Control Strategies List</a> co-ordinated by the Complexity Science Hub Vienna, Austria. We are in the process of gathering further information and aligning taxonomies for these items.</p>
    `;
  } else if (sourceNotes === "PolicyNZ") {
    return html`
      <p class="attribution">This item is sourced from <a target="_blank" href="https://covid19policywatch.org/">COVID-19 Policy Watch</a> co-ordinated by <a target="_blank" href="https://wearepolicy.com/">Policy</a>. We are in the process of gathering further information and aligning taxonomies for these items.</p>
      `;
  } else {
    return html`
      <p class="attribution">This item is from another data source. We are in the process of gathering further information and aligning taxonomies for these items.</p>
    `;
  }
}

// Shows a definition pair which presents a term/key and a description/value.
// These were originally paragraphs and breaks but are now structured as an HTML
// definition list, which means spacing should be automatically consistent as
// long as there are no interceding elements in the markup between definitions.
const definitionPair = (term, description) => {
  // Only render a definition if the description exists.
  if (description) {
    // NOTE: HTML spec allows wrapping DT and DD in a div for styling.
    return html`
      <div class="entry-def">
        <dt>${term}</dt>
        <dd>${description}</dd>
      </div>
    `;
  }
}

const metaEntryTemplate = ({entry, onCloseEntry}) => html`
  <div class="event-detail">
    <div class="event-description">
      <div class="entry">
        <div><button @click=${onCloseEntry}>‹ Back</button></div>
        <time>${moment(entry.startDate).format("LL")}</time>
        <b>– ${entry.countries.join(", ")}</b>
        <h1><a target="_blank" href="${entry.primaryLink}">${entry.title}</a></h1>

        ${otherLinksList(entry.otherLinks)}
        ${sourceAttribution(entry.sourceNotes)}

        <p class="entry-description">${entry.description}</p>

        <dl class="entry-defs">
          ${definitionPair("Level of Jurisdiction", entry.jurisdiction)}
          ${definitionPair("Lead People/Agency", entry.lead)}
          ${definitionPair("Type of Justification", entry.justification)}
          ${definitionPair("Source of Evidence or Justification", entry.evidenceSource)}
          ${definitionPair("Evidence/Justification", entry.evidenceDescription)}
        </dl>

        <div class="categories-list">
          ${entry.sectors.map(sector => (
                html`<span class="category category-sector">${sector}</span>`)
          )}
          ${entry.interventions.map(intervention => (
                html`<span class="category category-intervention">${intervention}</span>`)
          )}
          ${entry.categories.map(category => (
                html`<span class="category category-category">${category}</span>`)
          )}
        </div>
      </div>
    </div>
  </div>
`;

export {
  metaEntryTemplate
}
